import React, { useEffect, useState } from 'react'
import { Button, Container, Image } from 'react-bootstrap'
import moment from 'moment'
import { CLASSES } from '../../../assets/styles/classes'
import PlusIcon from '../../../assets/icons/common/plus-white.svg'
import TicketIcon from '../../../assets/icons/sidebar/ticket.svg'
import DropDownIcon from '../../../assets/icons/common/down-arrow-solid.svg'
import Table from '../../../components/table/Table'
import DropDownX from '../../../components/extras/DropDownX'
import SearchFilter from '../../../components/extras/SearchFilter'
import { useNavigate } from 'react-router-dom'
import HorizontalNavbar from '../components/HorizontalNavbar'
import HeaderInfo from '../../../components/extras/HeaderInfo'
import { useDispatch, useSelector } from 'react-redux'
import { setCurrentPage } from '../../../store/reducers'
import { PAGINATION_TYPES } from '../../../utils/constants'
import TableAction from '../components/TableAction'
import getPaginationData from '../../../store/actions/pagination'
import { TicketsService } from '../../../services'
import { viewDateFormat } from '../../../utils/helperFunctions'
import { TICKET_STATUS_OPTIONS } from '../../../utils/static_data'
import ButtonWithIcon from '../../../components/common/ButtonWithIcon'
import { USER_ROLES } from '../../../utils/userRole'

export const tickets_columns = [
  // {
  //   name: 'Ticket Id',
  //   width: '250px',
  //   style: {
  //     fontWeight: 'bold',
  //   },
  //   cell: ({ ticket_id }) => ticket_id,
  // },
  {
    name: 'Ticket Id',
    width: '150px',
    style: {
      fontWeight: 'bold',
    },
    cell: ({ ticket_no }) => ticket_no,
  },
  {
    name: 'Customer Name',
    minWidth: '180px',
    cell: ({ customer }) =>
      customer?.customer_first_name + ' ' + customer?.customer_last_name,
  },
  {
    name: 'Phone Number',
    width: '160px',
    cell: ({ customer }) => customer?.customer_phone1 || '—',
  },
  // {
  //   name: 'Email',
  //   minWidth: '180px',
  //   cell: ({ customer }) => customer?.customer_email_1 || 'N/A',
  // },
  {
    name: 'Email',
    minWidth: '180px',
    cell: ({ customer }) => (
      <div
        title={customer?.customer_email_1}
        style={{
          // maxWidth: '200px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {customer?.customer_email_1 || '—'}
      </div>
    ),
  },
  {
    name: 'Issue',
    minWidth: '180px',
    cell: ({ item_name }) => item_name,
  },
   {
    name: 'Date',
    minWidth: '130px',
    maxWidth: '250px',
    center: true,
    // compact: true,
    cell: ({ created_at }) => viewDateFormat(created_at),
  },
  {
    name: 'Status',
    width: '200px',
    center: true,
    cell: ({ ref_ticket_status_id }) => (
      <div
        style={{ borderRadius: 20, width: 170, border: '1px solid #F3922F' }}
        className={
          'p-1 text-center flex-shrink-0' +
          ' border-' +
          TICKET_STATUS_OPTIONS.find(
            (item) => item.value == ref_ticket_status_id,
          ).color +
          ' text-' +
          TICKET_STATUS_OPTIONS.find(
            (item) => item.value == ref_ticket_status_id,
          ).color
        }
      >
        {
          TICKET_STATUS_OPTIONS.find(
            (item) => item.value == ref_ticket_status_id,
          ).label
        }
        {/* <Image src={DropDownIcon} className={'ms-2'} /> */}
      </div>
    ),
  },
 
  {
    name: 'Actions',
    minWidth: '140px',
    center: true,
    compact: true,
    cell: (row) => <TableAction data={row} />,
  },
]

export default function Tickets() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { user_role } = useSelector(({ auth }) => auth)

  const { items, currentPage, rowsPerPage, total } = useSelector(
    ({ pagination }) => pagination[PAGINATION_TYPES.TICKETS],
  )
  const isLoading = useSelector(
    ({ loader }) => loader[PAGINATION_TYPES.TICKETS],
  )
  const [searchQuery, setSearchQuery] = useState({})

  useEffect(() => {
    dispatch(
      getPaginationData({
        key: PAGINATION_TYPES.TICKETS,
        ServiceName: TicketsService,
        page: currentPage,
        per_page: rowsPerPage,
        order_by: 'desc',
        ...searchQuery,
      }),
    )
  }, [currentPage, rowsPerPage, searchQuery])

  const handleSearch = (query) => {
    setSearchQuery(query)
    dispatch(
      setCurrentPage({
        key: PAGINATION_TYPES.TICKETS,
        currentPage: 1,
      }),
    )
  }

  const canAccess = user_role === USER_ROLES.ADMIN

  return (
    <Container fluid className='p-4 py-2 mt-2'>
      <div>
        <HeaderInfo
          Img={TicketIcon}
          title='All Ticket'
          element={`Total Ticket: ${total}`}
        />
        {/* <div className={CLASSES.content_between}>
           <h4 className={CLASSES.items_center}>
             {' '}
             <Image src={TicketIcon} className='me-3' /> All Ticket
           </h4>
           <div className={CLASSES.items_center + 'text-bold'}>
             Total Ticket: 500
           </div>
         </div> */}

        <div className={CLASSES.content_between + ' my-2 gap-2 flex-wrap'}>
          <HorizontalNavbar handleSearch={handleSearch} />
          {canAccess && (
            <ButtonWithIcon
              onClick={() => navigate('/ticket/create')}
              className={'border-0'}
              label='Add New Ticket'
              icon={PlusIcon}
            />
          )}
        </div>

        <div className='mb-5 mt-3 pt-4 border-radius-10 black-shadow-15'>
          <div
            className={CLASSES.content_between + 'px-4 mb-4 gap-2 flex-wrap'}
          >
            <SearchFilter
              handleSearch={handleSearch}
              name='ticket_id'
              placeholder='Ticket Id'
            />

            <DropDownX
              label='Sort by : '
              items={['Newest', 'Oldest']}
              handleSearch={(item) =>
                handleSearch({ order_by: item == 'Newest' ? 'desc' : 'asc' })
              }
            />
          </div>

          <Table
            columns={tickets_columns}
            data={items || []}
            progressPending={isLoading}
            customStyle={{
              rows: {
                style: {
                  borderTop: '0px solid #E0E0E0',
                  borderBottom: '1px solid #E0E0E0 !important',
                  display: 'flex !important',
                  alignItems: 'center !important',
                  padding: 5,
                },
              },
            }}
          />
        </div>
      </div>
    </Container>
  )
}
